import {Component, Input} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

import {PermissionsService} from "../../services/permissions/permissions.service";
import {ClientsService} from "../../models/clients/clients.service";
import {floatingButtonX} from "./xservice";

@Component({
    selector: 'floating-button',
    templateUrl: 'template.html',
    styleUrls: ['styles.css']
})
export class FloatingButtonComponent
{
    globalInfo: any;
    isVisible: any = false;

    loadedClientData: any = false;
    isLoadingClientData: any = false;

    @Input() buttonType: any = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        public permission: PermissionsService,
        public clientsService: ClientsService
    ) {
        this.globalInfo = floatingButtonX();
    }

    private onceSetId: any = {};

    ngOnInit() {

    }

    gotoCurrentPricing() {
        if (! this.panelVisibility) return;

        try {
            this.router.navigateByUrl('/funding-specialist/' +
                (this.globalInfo.hasDebt ? 'funded-accounts' : 'lead-accounts') +
                '/clients/' + 
                (this.globalInfo.clientId * 1) + '/pricing');
        } catch (e) {
        }
    }

    gotoAllPricings() {
        if (! this.panelVisibility) return;

        try {
            this.router.navigateByUrl('/underwriter/accounts/clients/' + 
                (this.globalInfo.clientId * 1) + '/pricings-by-debts');
        } catch (e) {
        }
    }

    private _once: any;
    get panelVisibility(): any {
        if (! this.permission.can('floatingButton.using') || ! this.globalInfo.clientId) return false;
        if (! this.buttonType) return true;

        if (this.loadedClientData && this.loadedClientData.id == this.globalInfo.clientId) {
            return this.loadedClientData.max_pricing_id ? true : false;
        }

        if (this.isLoadingClientData != this.globalInfo.clientId) {
            this.isLoadingClientData = this.globalInfo.clientId;
            this._once = {};
            (() => {
                let _o = this._once;
                this.clientsService.getForFloatingButton(this.globalInfo.clientId)
                    .subscribe((res) => {
                        if (this._once !== _o) return;
                        this.loadedClientData = res.data;
                        this.isLoadingClientData = false;
                    });
            }) ();
        }

        return false;
    }

    getMarginLeft(el: any) {
        let width: any = -16;
        if (this.isVisible)
            width = -2 - el.clientWidth;
        return '' + width + 'px';
    }

    get additionStyleClassName(): any {
        if (! this.buttonType) return '';

        return 'custom_style_all_pricings';
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/floating-button/component.ts